import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { triggerHaptic } from '../../utils/haptics';

const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      triggerHaptic.success();
    };
    const handleOffline = () => {
      setIsOnline(false);
      triggerHaptic.heavy();
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 'env(safe-area-inset-top, 0px)',
      left: 0,
      right: 0,
      backgroundColor: '#c30000',
      color: '#fff',
      textAlign: 'center',
      padding: '8px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    }}>
      <WifiOff size={16} />
      You are currently offline. Some features may be limited.
    </div>
  );
};

export default OfflineBanner;
